import comp from "./IBResources";
export default comp;
